<template>
    <b-modal
      id="developermodal"
      :title="formModal.title"
      @hidden="resetModal"
      @ok="handleSubmit"
      ok-title="Submit"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit" novalidate>

        <b-form-group label="Name" label-for="name-input">
            <b-form-input id="name-input" v-model="form.name" :state="validateState('name')"></b-form-input>
        </b-form-group>

      </form>
    </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
    data(){
        return this.initData();
    },
    validations: {
        form: {
            name: { required },
        }
    },
    methods: {
        initData(){
            return {
                form:{
                    id: null,
                    name: null,
                },
                formModal:{
                    title: null
                },
                isEdit: false,
            }
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        openModal(){
            this.isEdit = false;
            this.formModal.title = "Add Developer";
            this.$bvModal.show('developermodal');
        },
        async editModal(id){
            this.isEdit = true;
            this.formModal.title = "Edit Developer";
            try {
                const { data } = await axios.get(route("admin.developers.show", id));
                this.form = data;
                this.$bvModal.show('developermodal');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        resetModal(){
            this.form = this.initData().form;
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        handleSubmit(bvModalEvt){
            bvModalEvt.preventDefault();
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            if(this.isEdit == true){
                this.submitUpdate();
            }else{
                this.submitSave();
            }
        },
        errorMessage(e){
            const errors = e.response && e.response.data && e.response.data.errors;
            return errors ? Object.values(errors).flat().join(' ') : '';
        },
        async submitSave(){
            try {
                await axios.post(route("admin.developers.store"), {
                    form: this.form
                });
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('developermodal');
                reloadTable();
            } catch (e) {
                console.log(e);
                this.$swal('Error!', this.errorMessage(e), 'error');
            }
        },
        async submitUpdate(){
            try {
                await axios.put(route("admin.developers.update", this.form.id), {
                    form: this.form
                });
                this.$swal('Saved!', '', 'success');
                this.$bvModal.hide('developermodal');
                reloadTable();
            } catch (e) {
                console.log(e);
                this.$swal('Error!', this.errorMessage(e), 'error');
            }
        },
        async deleteDeveloper(id){
             this.$swal({
                title: 'Are you sure?',
                text: "Houses already using this developer will keep its name.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await axios.delete(route("admin.developers.destroy", id ));
                        this.$swal({
                            title: 'Deleted!',
                            text: 'Developer has been deleted.',
                            icon: 'success',
                            didClose: () =>{
                                reloadTable();
                            }
                        })
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        },
    }
}
</script>
